export interface LegendItem {
  range: string;
  color: string;
  descriptionKey: string;
  labelColor?: string;
}

export const INDEX_LEGENDS: Record<string, LegendItem[]> = {
  'Ndvi': [
    { range: '< 0', color: '#FF0000', descriptionKey: 'LEGEND.NDVI.WATER' },
    { range: '0 — 0.2', color: '#FFA500', descriptionKey: 'LEGEND.NDVI.BARE_SOIL' },
    { range: '0.2 — 0.4', color: '#FFFF00', descriptionKey: 'LEGEND.NDVI.START_GROWTH' },
    { range: '0.4 — 0.6', color: '#90EE90', descriptionKey: 'LEGEND.NDVI.NORMAL' },
    { range: '0.6 — 0.8', color: '#00FF00', descriptionKey: 'LEGEND.NDVI.GOOD' },
    { range: '> 0.8', color: '#008000', descriptionKey: 'LEGEND.NDVI.DENSE' },
  ],
  'Gndvi': [
    { range: '< 0', color: '#FFFFFF', descriptionKey: 'LEGEND.GNDVI.NO_DATA' },
    { range: '0 — 0.25', color: '#98FB98', descriptionKey: 'LEGEND.GNDVI.LOW_NITROGEN' },
    { range: '0.25 — 0.5', color: '#3CB371', descriptionKey: 'LEGEND.GNDVI.MODERATE' },
    { range: '0.5 — 0.75', color: '#2E8B57', descriptionKey: 'LEGEND.GNDVI.GOOD' },
    { range: '> 0.75', color: '#006400', descriptionKey: 'LEGEND.GNDVI.HIGH' },
  ],
  'Evi': [
    { range: '< 0.0', color: 'linear-gradient(to right, #465573, #5F6E8C)', descriptionKey: 'LEGEND.EVI.DEEP_WATER' },
    { range: '0.0 – 0.2', color: 'linear-gradient(to right, #965A28, #CD8C3C)', descriptionKey: 'LEGEND.EVI.SOIL_WEAK' },
    { range: '0.2 – 0.4', color: 'linear-gradient(to right, #CD8C3C, #FFE628)', descriptionKey: 'LEGEND.EVI.START_STRESS' },
    { range: '0.4 – 0.6', color: 'linear-gradient(to right, #FFE628, #AAEB64)', descriptionKey: 'LEGEND.EVI.TRANSITION' },
    { range: '0.6 – 0.8', color: 'linear-gradient(to right, #AAEB64, #46BE55)', descriptionKey: 'LEGEND.EVI.HEALTHY' },
    { range: '≥ 0.8', color: 'linear-gradient(to right, #46BE55, #0A6E23)', descriptionKey: 'LEGEND.EVI.DENSE' },
  ],
  'Arvi': [
    { range: '< 0.0', color: 'linear-gradient(to right, #465573, #5F6E8C)', descriptionKey: 'LEGEND.ARVI.DEEP_WATER' },
    { range: '0.0 – 0.2', color: 'linear-gradient(to right, #965A28, #CD8C3C)', descriptionKey: 'LEGEND.ARVI.SOIL_WEAK' },
    { range: '0.2 – 0.4', color: 'linear-gradient(to right, #CD8C3C, #FFE628)', descriptionKey: 'LEGEND.ARVI.START_STRESS' },
    { range: '0.4 – 0.6', color: 'linear-gradient(to right, #FFE628, #AAEB64)', descriptionKey: 'LEGEND.ARVI.TRANSITION' },
    { range: '0.6 – 0.8', color: 'linear-gradient(to right, #AAEB64, #46BE55)', descriptionKey: 'LEGEND.ARVI.HEALTHY' },
    { range: '≥ 0.8', color: 'linear-gradient(to right, #46BE55, #0A6E23)', descriptionKey: 'LEGEND.ARVI.DENSE' },
  ],
  'Orvi': [
    { range: '< 0.8', color: '#5F6E8C', descriptionKey: 'LEGEND.ORVI.WATER' },
    { range: '0.8 – 1.2', color: '#8B4513', descriptionKey: 'LEGEND.ORVI.DRY_SOIL' },
    { range: '1.2 – 1.6', color: '#CD8C3C', descriptionKey: 'LEGEND.ORVI.WET_SOIL' },
    { range: '1.6 – 2.0', color: '#FFFF00', descriptionKey: 'LEGEND.ORVI.START_STRESS' },
    { range: '2.0 – 2.5', color: '#90EE90', descriptionKey: 'LEGEND.ORVI.NORMAL' },
    { range: '> 2.5', color: '#006400', descriptionKey: 'LEGEND.ORVI.DENSE' },
  ],
  'Osavi': [
    { range: '< 0.0', color: '#8B4513', descriptionKey: 'LEGEND.OSAVI.BARE_SOIL' },
    { range: '0.0 — 0.2', color: '#D2B48C', descriptionKey: 'LEGEND.OSAVI.DRY_VEG' },
    { range: '0.2 — 0.35', color: '#FFDC28', descriptionKey: 'LEGEND.OSAVI.STRESS' },
    { range: '0.35 — 0.5', color: '#A0DC64', descriptionKey: 'LEGEND.OSAVI.MODERATE' },
    { range: '0.5 — 0.65', color: '#50B446', descriptionKey: 'LEGEND.OSAVI.HEALTHY' },
    { range: '> 0.65', color: '#14641E', descriptionKey: 'LEGEND.OSAVI.DENSE' },
  ],
  'Mndwi': [
    { range: '< 0.0', color: 'linear-gradient(to right, #8B4513, #FFA500)', descriptionKey: 'LEGEND.MNDWI.DRY_SOIL' },
    { range: '0.0 – 0.3', color: 'linear-gradient(to right, #FF8C2A, #FFFFFF)', descriptionKey: 'LEGEND.MNDWI.WET_SOIL' },
    { range: '> 0.3', color: 'linear-gradient(to right, #FFFFFF, #0000FF)', descriptionKey: 'LEGEND.MNDWI.WATER' },
  ],
  'Ndmi': [
    { range: '< 0', color: '#ADD8E6', descriptionKey: 'LEGEND.NDMI.DEFICIT' },
    { range: '0 – 0.3', color: '#00BFFF', descriptionKey: 'LEGEND.NDMI.DRY_RISK' },
    { range: '0.3 – 0.7', color: '#0000FF', descriptionKey: 'LEGEND.NDMI.MODERATE' },
    { range: '0.7 - 1.0', color: '#00008B', descriptionKey: 'LEGEND.NDMI.GOOD' },
  ],
  'Ndwi': [
    { range: '0.2 — 1.0', color: '#1E90FF', descriptionKey: 'LEGEND.NDWI.WATER' },
    { range: '0.0 — 0.2', color: '#87CEEB', descriptionKey: 'LEGEND.NDWI.FLOODING' },
    { range: '-0.3 — 0.0', color: '#F4A460', descriptionKey: 'LEGEND.NDWI.MODERATE_DROUGHT' },
    { range: '-1.0 — -0.3', color: '#8B4513', descriptionKey: 'LEGEND.NDWI.DROUGHT' },
  ]
};
